export const TileTypes: any = {
    Blue: 'Blue',
    Red: 'Red',
    Empty: 'Empty'
}
